<template>
  <ul class="waiting-open-times">
    <li
      v-bind:key="title"
      v-for="{ title } in items">
      <button
        class="waiting-open-times__item"
        title="Записать на прием"
        type="button"
        v-on:click="onClick(title)">{{ title }}</button>
    </li>
  </ul>
</template>
<script>
/**
 * @description Свободное время для записи из листа ожидания.
 * @type {Vue}
 */
export default {
  methods: {
    /**
     * @description Обработать выбор времени.
     * @param {string} value Значение.
     * @returns {void}
     */
    onClick(value) {
      this.$emit('input', value);
    },
  },
  name: 'WaitingOpenTimes',
  props: {
    /**
     * @description Свободное время.
     * @type {any[]}
     */
    items: {
      default: () => [],
      type: Array,
    },
  },
};
</script>
<style lang="scss" scoped>
@use "@/scss/buttons";
.waiting-open-times {
  display: flex;
  flex-direction: column;
  gap: .5rem;
  list-style-type: none;
  padding: 1rem 0;
}
.waiting-open-times .waiting-open-times__item {
  @include buttons.btn-blue(max(20rem, 80%), 3rem, 1rem);
}
</style>
